/**
 * Client-side safety filter for ExploreContent publish/unpublish dates.
 * Filters out content that has a publishDate in the future or an unpublishDate in the past.
 */
import dayjs from 'dayjs';

export function isPublished(item: { publishDate?: dayjs.Dayjs; unpublishDate?: dayjs.Dayjs }): boolean {
  const now = dayjs();

  if (item.publishDate && item.publishDate.isAfter(now)) {
    return false;
  }

  if (item.unpublishDate && item.unpublishDate.isBefore(now)) {
    return false;
  }

  return true;
}
